<template>
  <div class="home">

    <WorkCover>
      <template slot="cover">
        <img class="bg-cover" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/thumbs%2FFrame%2026%204.jpg?alt=media&token=8d9372ae-38a8-484c-bcbd-1d03b5680ff4" alt="">
      </template>
    </WorkCover>

    <WorkHeader>
      <template slot="year">2021</template>
      <template slot="client">Söderberg & Partners</template>
      <template slot="type">
        <div>
          <div>Concept</div>
          <div>Brand Design</div>
          <div>Digital Design</div>
        </div>
      </template>
      <template slot="website">
        <a href="https://apps.apple.com/se/app/levler/id1617260606" target="_blank">Download the App</a>
      </template>
      <template slot="desc">
          Söderberg & Partners is one of Sweden's leading financial advisers and brokers of insurance and financial products.
          <br><br>
          MESH was commissioned by Söderberg & Partners at the start of 2021 to create a new financial service with the brief of making saving cheaper, easier and more accessible for everyone.
          This resulted in the new financial app Levler (formerly known as Ticker). 
          MESH helped to develop the conceptual strategy, the brand design and the digital design.
          This was developed as a startup and to become an innovation leader in its category. Which marks the start of a new exciting chapter in Söderberg & Partner’s legacy.
      </template>
    </WorkHeader>

    <WorkTicker/>

    <Index/>

    <Footer/>

  </div>
</template>

<script>
import WorkCover from '@/components/work/WorkCover.vue'
import WorkHeader from '@/components/work/WorkHeader.vue'
import WorkTicker from '@/components/work/WorkTicker.vue'
import LogoAni from '@/components/LogoAni.vue'
import Slideshow from '@/components/Slideshow.vue'
import Index from '@/components/Index.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Algorhythm',
  components: {
    WorkHeader,
    WorkCover,
    LogoAni,
    Slideshow,
    Index,
    Footer,
    WorkTicker
  }
}
</script>
<style scoped lang="scss">
@import "@/scss/_vars.scss";
@import "@/scss/_mixins.scss";
@import "@/scss/_classes.scss";

</style>
